import type { TFiltersContextOptions } from "@amphore-dev/amphore-lib";

import { useFiltersContext } from "@/hooks/useFiltersContext";

import { TTasksFilters } from "@/types";

/**
 * The tasks period follows the URL (`?dateFrom=&dateTo=`): read once on
 * mount, written on every change. Only the period - the project is
 * `?project=` and the view the path (see UHomePath), with one writer
 * each. The options are per hook call in the lib, so every home widget
 * must go through this hook and nothing outside the home page should:
 * a consumer elsewhere would write the period onto its own page's URL.
 */
export const TASKS_FILTERS_OPTIONS: Partial<
	TFiltersContextOptions<TTasksFilters>
> = {
	updateUrlParams: true,
	params: { dateFrom: true, dateTo: true },
};

export const useTasksFilters = () =>
	useFiltersContext("tasks", TASKS_FILTERS_OPTIONS);
